import React, { memo, useEffect, useRef, useState } from 'react';

const pad2 = (n) => String(n).padStart(2, '0');

const formatTs = (d) => {
  // YYYY-MM-DD HH:MM:SS
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
};

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const makeLine = () => {
  const now = new Date();
  const host = pick(['edge-01', 'soc-01', 'core-02', 'fw-01']);
  const sev = pick(['INFO', 'INFO', 'INFO', 'WARN', 'ALERT']);
  const src = pick(['auth', 'edr', 'dns', 'fw', 'siem', 'web']);
  const msg = pick([
    'rule_match id=R-1042 score=22',
    'blocked outbound connection proto=tcp',
    'suspicious process spawn parent=explorer.exe',
    'login success user=dcunha',
    'login failed user=unknown',
    'dns query domain=cdn-assets',
    'http 200 /api/health',
    'portscan detected src=10.0.0.23',
    'ioc hit hash=sha256:... (truncated)',
  ]);

  return `${formatTs(now)}  ${host}  ${sev}  ${src}: ${msg}`;
};

// Background log stream. Tap/click anywhere on Hero toggles pause.
const HeroBackgroundLogs = () => {
  const ref = useRef(null);
  const pausedRef = useRef(false);
  const intervalRef = useRef(0);
  const [lines, setLines] = useState(() => {
    const initial = [];
    for (let i = 0; i < 42; i += 1) initial.push(makeLine());
    return initial;
  });

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      pausedRef.current = true;
    }

    const tick = () => {
      setLines((prev) => {
        const next = prev.slice(1);
        next.push(makeLine());
        return next;
      });
    };

    intervalRef.current = window.setInterval(() => {
      if (!pausedRef.current) tick();
    }, prefersReducedMotion ? 1200 : 380);

    const onPointerDown = (e) => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) return;
      if (prefersReducedMotion) return;
      pausedRef.current = !pausedRef.current;
      el.dataset.paused = pausedRef.current ? 'true' : 'false';
    };

    window.addEventListener('pointerdown', onPointerDown, { passive: true });
    return () => {
      window.clearInterval(intervalRef.current);
      window.removeEventListener('pointerdown', onPointerDown);
    };
  }, []);

  return (
    <div ref={ref} className="hero-bg-logs" aria-hidden="true" data-paused="false">
      <pre className="hero-bg-logs-pre">{lines.join('\n')}</pre>
    </div>
  );
};

export default memo(HeroBackgroundLogs);
